export default __webpack_public_path__ + "static/media/IkonBrugDinForsikring.01ac02ef.svg";